import { Booking } from '../models/booking.models';

const STORAGE_KEY = 'dd-last-booking';

export interface LastBooking {
  outbound: Booking;
  inbound: Booking | null;
}

export function saveLastBooking(outbound: Booking, inbound: Booking | null): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ outbound, inbound }));
  } catch {
    // Ignore quota / private-mode failures.
  }
}

export function readLastBooking(): LastBooking | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as LastBooking;
    if (!parsed?.outbound?.referenceCode) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}
